var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHeaderMobileLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 28,
    viewBox: "0 0 46 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.462 22.9749L0.341372 27.6106C0.199088 27.6608 0.0322266 27.5878 0.0322266 27.4752V0.517944C0.0322266 0.406562 0.197147 0.333609 0.338785 0.38181L13.462 4.86447V22.9749Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0093 4.87351L17.082 0.110107V27.8874L14.0093 22.9748V4.87351Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeaderMobileLogoDark);
export default __webpack_public_path__ + "static/media/ic-header-mobile-logo-dark.236918e1c3868727c0421905b74c39c5.svg";
export { ForwardRef as ReactComponent };